import React, { useState, useEffect } from 'react';

const WEATHER_CONDITIONS = {
  winter: ['Snowy', 'Blizzard', 'Cold', 'Foggy'],
  spring: ['Rainy', 'Windy', 'Mild', 'Cloudy'],
  summer: ['Sunny', 'Hot', 'Warm', 'Clear'],
  autumn: ['Chilly', 'Windy', 'Overcast', 'Rain']
};

const DEFAULT_WEATHER_RANGES = {
  winter: { min: 0, max: 40 },
  spring: { min: 40, max: 60 },
  summer: { min: 60, max: 80 },
  autumn: { min: 40, max: 60 }
};

const getSeasonalWeather = (ranges) => {
  const month = new Date().getMonth();
  let season;
  if (month < 2 || month === 11) season = 'winter';
  else if (month < 5) season = 'spring';
  else if (month < 8) season = 'summer';
  else season = 'autumn';

  const { min, max } = ranges[season];
  const temperature = Math.floor(Math.random() * (max - min + 1)) + min;
  const randomWeather = WEATHER_CONDITIONS[season][Math.floor(Math.random() * WEATHER_CONDITIONS[season].length)];

  return `${randomWeather}, ${temperature}°F`;
};

const renderParagraphs = (content) =>
  content.split('\n').map((paragraph, index) => (
    paragraph.trim() ? <p key={index}>{paragraph.trim()}</p> : null
  ));

const NewsArchive = ({ masthead, dateLabel, cta, articles, weatherRanges = DEFAULT_WEATHER_RANGES, classNames }) => {
  const articleDates = Object.keys(articles);
  const [selectedArticleDate, setSelectedArticleDate] = useState(articleDates[0]);
  const [weather, setWeather] = useState('');
  const selectedArticle = articles[selectedArticleDate];

  useEffect(() => {
    setWeather(getSeasonalWeather(weatherRanges));
  }, [weatherRanges]);

  return (
    <div className={classNames.root}>
      <header className={classNames.header}>
        <div className={classNames.headerLeft}>
          <p className={classNames.dateWeather}>{dateLabel} &#8226; {weather}</p>
        </div>

        <div className={classNames.headerCenter}>
          <h1>{masthead}</h1>
        </div>

        <div className={classNames.headerRight}>
          <a href={cta.href} className={classNames.ctaButton} target="_blank" rel="noopener noreferrer">
            {cta.label}
          </a>
        </div>
      </header>

      <div className={classNames.content}>
        <aside className={classNames.sidebar}>
          {articleDates.map((date) => (
            <p key={date} onClick={() => setSelectedArticleDate(date)}>
              {date}: {articles[date].title}
            </p>
          ))}
        </aside>

        <main className={classNames.article}>
          <h2>{selectedArticle.title}</h2>
          <p className={classNames.byline}>{selectedArticle.byline}</p>
          {renderParagraphs(selectedArticle.content)}
        </main>
      </div>
    </div>
  );
};

export default NewsArchive;
